import "../css/index.css";

(() => {
	document.addEventListener("DOMContentLoaded", function () {
	    const categoryButtons = document.querySelectorAll(".js-machine-category");
	    const machineItems = document.querySelectorAll(".js-machine-item");
	    const defaultMessage = document.getElementById("fp-machines-default");
	    const machineModelsSection = document.getElementById("machine-models");

	    categoryButtons.forEach(button => {
	        button.addEventListener("click", function () {
	            const selectedSeries = this.dataset.machineSeries;

	            // Reset all machine items
	            machineItems.forEach(item => item.classList.add("hidden"));
	            
	            // Show only matching items
	            let matchingItems = Array.from(machineItems).filter(item => item.dataset.machineCat === selectedSeries);
	            
	            if (matchingItems.length > 0) {
	                defaultMessage.classList.add("hidden"); // Hide the default message
	                matchingItems.forEach(item => item.classList.remove("hidden"));
	            } else {
	                defaultMessage.classList.remove("hidden"); // Show the default message if no matches found
	            }
	            
	            // Scroll to the machine models section
	            if (machineModelsSection) {
	                machineModelsSection.scrollIntoView({ behavior: "smooth" });
	            }
	        });
	    });
	});
})();

(() => {
	document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById("manual-search-sn");
  const input = form.querySelector('input[name="sn_search"]');
  const manualElements = document.querySelectorAll("[data-sn-range]");

  // Jeśli żaden element nie posiada atrybutu data-sn-range, zakończ działanie skryptu
  if (manualElements.length === 0) {
    console.warn("Brak elementów z atrybutem data-sn-range.");
    return;
  }

  function filterElements() {
    const inputValue = input.value.trim();

    // Jeśli pole jest puste, wyświetl wszystkie elementy
    if (inputValue === "") {
      manualElements.forEach(el => el.classList.remove("hidden"));
      return;
    }

    const enteredSerial = parseInt(inputValue, 10);

    // Jeśli wartość nie jest liczbą, nie filtruj
    if (isNaN(enteredSerial)) {
      console.warn("Podano nieprawidłowy numer seryjny.");
      return;
    }

    manualElements.forEach(el => {
      const rangeData = el.dataset.snRange; // Format "nr1:nr2" lub "nr1:latest"
      const [startStr, endStr] = rangeData.split(":");
      const start = parseInt(startStr, 10);
      let end = Infinity;

      if (endStr !== "latest") {
        end = parseInt(endStr, 10);
      }

      // Jeżeli numer seryjny mieści się w przedziale - usuń klasę hidden, w przeciwnym razie ją dodaj
      if (enteredSerial >= start && enteredSerial <= end) {
        el.classList.remove("hidden");
      } else {
        el.classList.add("hidden");
      }
    });
  }

  // Sprawdź wartość pola przy każdej zmianie
  input.addEventListener("input", filterElements);

  // Opcjonalnie - obsługa wysłania formularza
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    filterElements();
  });
});


})();